<template>
  <v-layout row wrap justify-center align-center fill-height login mx-0 my-0>
    <v-flex xs12 login__title>
      <a href="https://wiam.ru">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="30px"
          height="30px"
        >
          <path
            d="M27.391,15.771 C26.469,15.771 25.663,15.287 25.199,14.559 L23.017,14.580 L21.358,14.596 C20.850,14.629 20.345,14.330 20.066,13.884 L19.317,12.683 L14.535,23.158 C14.289,23.699 13.752,24.044 13.165,24.044 C13.143,24.044 13.123,24.044 13.102,24.043 C12.490,24.017 11.954,23.622 11.744,23.042 L9.734,17.462 L7.216,17.462 L5.019,17.462 C4.551,18.169 3.755,18.636 2.849,18.636 C1.408,18.636 0.240,17.458 0.240,16.009 C0.240,14.559 1.408,13.383 2.849,13.383 C3.694,13.383 4.438,13.794 4.913,14.421 L7.174,14.421 L10.793,14.421 C11.429,14.421 11.995,14.822 12.212,15.423 L13.328,18.522 L17.740,8.859 C17.971,8.351 18.459,8.013 19.014,7.976 C19.560,7.940 20.095,8.213 20.390,8.685 L22.174,11.547 L23.070,11.538 L25.358,11.516 C25.836,10.913 26.564,10.518 27.391,10.518 C28.832,10.518 30.000,11.694 30.000,13.145 C30.000,14.595 28.832,15.771 27.391,15.771 ZM25.018,9.172 C22.983,5.518 19.104,3.041 14.655,3.041 C9.350,3.041 4.847,6.562 3.327,11.405 C3.167,11.388 3.012,11.356 2.849,11.356 C1.770,11.356 0.789,11.746 -0.000,12.373 C1.239,5.353 7.332,0.000 14.655,0.000 C20.581,0.000 25.693,3.508 28.091,8.562 C27.861,8.526 27.631,8.491 27.391,8.491 C26.520,8.491 25.714,8.749 25.018,9.172 ZM4.103,20.467 C6.079,24.317 10.062,26.960 14.655,26.960 C20.306,26.960 25.039,22.963 26.234,17.633 C26.607,17.730 26.989,17.799 27.391,17.799 C28.095,17.799 28.755,17.626 29.353,17.341 C28.231,24.502 22.077,30.000 14.655,30.000 C8.213,30.000 2.729,25.854 0.655,20.080 C1.311,20.439 2.051,20.663 2.849,20.663 C3.286,20.663 3.701,20.582 4.103,20.467 Z"
            fill-rule="evenodd"
            fill="#ffffff"
          />
        </svg>
        WIAM
      </a>
    </v-flex>

    <v-flex login__form>
      <h2 class="mb-4">{{statusText}}</h2>
      <p v-if="errors">Произошла ошибка</p>
      <v-alert
        style="word-break: break-all;"
        v-if="errors"
        text
        color="warning"
        outlined
        dense
        border="left"
        transition="scale-transition"
        tile
        min-width="100%"
      >{{errors}}</v-alert>

      <v-icon v-if="dataResult" color="green" size="75">mdi-checkbox-marked-circle</v-icon>

      <v-alert
        style="word-break: break-all;"
        v-if="dataResult"
        text
        color="success"
        outlined
        class="mt-10"
        dense
        border="left"
        transition="scale-transition"
        tile
        min-width="100%"
      >{{dataResult.json_value.email}}</v-alert>

      <loading v-if="isLoaded" />
    </v-flex>
  </v-layout>
</template>



<script>
import { apiCallTrue } from "@/utils/api";

export default {
  name: "PublicUnsubscribe",
  data: () => ({
    errors: null,
    statusText: "Отписка от рассылки",
    isLoaded: false,
    dataResult: null
  }),
  methods: {
    async apiUnsubscribe() {
      this.errors = null;
      this.dataResult = null;
      let { hash } = this.$route.query;
      const url = `v1/users/unsubscribe`;

      await apiCallTrue({
        url,
        method: "POST",
        data: { hash: hash }
      })
        .then(response => {
          this.dataResult = response.data.data;
          this.statusText = "Вы успешно отписались от рассылки";
        })
        .catch(error => {
          this.errors = error.message;
        })
        .finally(() => {
          this.isLoaded = false;
        });
    }
  },
  mounted() {
    this.apiUnsubscribe();
  }
  /*components: {
        Bid,
    }*/
};
</script>
<style lang="scss">
.login {
  background: url(../../assets/images/login.jpg) no-repeat center top;
  background-size: cover;
  position: relative;
  align-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
  &__title {
    a {
      color: #fff;
      text-align: center;
      font-size: 25px;
      border: 0 !important;
      position: relative;
      margin-bottom: 60px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      font-weight: bold;
    }

    svg {
      margin-right: 16px;
    }
  }

  &__form {
    background: #fff;
    box-shadow: 0 0 20px #000;
    border-radius: 4px;
    border: 1px solid #eee;
    padding: 35px 40px 20px !important;
    max-width: 400px;
    text-align: center;
    position: relative;

    p {
      font-size: 0.9em;
      color: #aaa;
    }

    &-recovery {
      text-align: right;
      margin-top: -16px;
      position: relative;
      z-index: 1;

      em {
        color: #aaa;
        font-style: italic;
        font-size: 13px;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &-tab {
      &-name {
        width: calc(50% - 15px);
      }

      &--empty {
        margin: 8px 0 0;
        color: #aaa;
        font-size: 14px;
        font-style: italic;
        padding: 50px 0;
      }
    }
    .v-input__icon .v-icon {
      font-size: 20px !important;
    }
  }
  &__fullname {
    height: 0px;
    overflow: hidden;
    opacity: 0;
  }
}
.pass::-webkit-credentials-auto-fill-button {
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
}
.pass:focus::-webkit-textfield-decoration-container {
  visibility: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
}
</style>